import { QuestionnaireQuestions } from '@getpopsure/qnr-framework';
import GenericReview from 'components/review';
import { GeneralQuestion } from 'features/generalQuestionnaire/model';
import { InsuranceTypes } from 'models/insurances/types';
import { Policy } from 'models/policies';
import {
  QuestionReviewValueType,
  ReviewProps,
} from 'SignupQuestionnaire/components/Review/Review';

import { ADJUST_POLICY_QUESTION_ID } from '../../models';
import { getReviewValue } from './getReviewValues';
import { prepareReviewValues } from './prepareReviewValues';

export const PreviewAdjustPolicyReview = <
  Questionnaire extends QuestionnaireQuestions
>(
  props: Omit<
    ReviewProps<Questionnaire>,
    'createPostQuote' | 'insuranceType' | 'verticalId' | 'requestType'
  > & {
    configuration: {
      questions: GeneralQuestion;
      policy: Policy;
    };
  }
) => {
  const {
    featureName,
    reviewValues,
    questionnaireAnswers,
    onSubmitValue,
    configuration,
    title,
    ctaText,
    description,
  } = props;

  const { questions } = configuration;

  const mappedReviewValues = reviewValues.flatMap((reviewItem) => {
    const questionId = reviewItem.path ?? '';

    const value = getReviewValue({
      questions,
      questionId,
      questionnaireAnswers,
    });

    return value !== null
      ? [
          {
            ...reviewItem,
            value,
          } as QuestionReviewValueType<Questionnaire>,
        ]
      : [];
  });

  const questionReviewValues = prepareReviewValues(
    questionnaireAnswers,
    mappedReviewValues
  );

  const hasAssociatedQuestion = (questionId: string) =>
    !!questions.find((q) => q.id === questionId);

  const questionReviewValuesWithFixedPaths = questionReviewValues.map((v) =>
    v.path && hasAssociatedQuestion(v.path)
      ? v
      : { ...v, path: ADJUST_POLICY_QUESTION_ID }
  );

  const handleSubmit = async () => {
    onSubmitValue(true);
  };

  return (
    <GenericReview
      title={<h1 className="p-h1 mb8">{title}</h1>}
      handleSubmit={handleSubmit}
      insuranceType={featureName as InsuranceTypes}
      questionReviewValues={questionReviewValuesWithFixedPaths}
      ctaText={ctaText}
      confirmationText=""
      description={description}
      isDescriptionVisible
    />
  );
};
